/*
 * The words crew read on My pay and the clock, in English and Spanish (spec 3.8: My pay is in Spanish when the person's
 * language is Spanish). Shared so the web app and the phone app say the same thing. {name} marks a value to fill in.
 */
export const PAY_WORDS = {
  en: {
    myPay: "My pay",
    myPayIntro: "Your pay for each week. Tap a week to see its jobs.",
    notLinked: "Your sign in is not on the team list yet. Ask the office to add you.",
    noWeeks: "No pay yet",
    noWeeksHint: "When a job you worked is paid, it shows here.",
    paid: "Paid",
    owes: "You owe",
    open: "Not paid yet",
    current: "This week so far",
    paidOn: "Paid {date}",
    payday: "Payday {date}",
    week: "Week of {date}",
    jobs: "Jobs",
    tips: "Tips",
    hours: "Hours",
    hourlyPay: "Pay for hours",
    jobPay: "Job pay",
    total: "Total",
    cash: "Cash you kept",
    owedBefore: "Owed from earlier weeks",
    owesNote: "Clients paid you {amount} more than your pay. It comes off your next pay.",
    owedNote: "You owed {amount} from the week of {date}. It comes off this week.",
    frozen: "This week is paid. Work after that is in the week of {date}.",
    lateRow: "From the week of {date}, done after it was paid",
    changeRow: "Change to a job after the week of {date} was paid",
    hoursRow: "Change to hours for the week of {date}",
    noLines: "No jobs in this week.",
    back: "All weeks",
    clockIn: "Clock in",
    clockOut: "Clock out",
    onClock: "On the clock since {time}",
    offClock: "Not on the clock",
    today: "Today {hours}",
    clockedIn: "Clocked in",
    clockedOut: "Clocked out",
  },
  es: {
    myPay: "Mi pago",
    myPayIntro: "Tu pago de cada semana. Toca una semana para ver sus trabajos.",
    notLinked: "Tu cuenta todavía no está en la lista del equipo. Pide a la oficina que te agregue.",
    noWeeks: "Todavía no hay pago",
    noWeeksHint: "Cuando se pague un trabajo que hiciste, aparece aquí.",
    paid: "Pagado",
    owes: "Debes",
    open: "Sin pagar",
    current: "Esta semana hasta ahora",
    paidOn: "Pagado el {date}",
    payday: "Día de pago {date}",
    week: "Semana del {date}",
    jobs: "Trabajos",
    tips: "Propinas",
    hours: "Horas",
    hourlyPay: "Pago por horas",
    jobPay: "Pago por trabajos",
    total: "Total",
    cash: "Efectivo que te quedaste",
    owedBefore: "Lo que debías de semanas anteriores",
    owesNote: "Los clientes te pagaron {amount} más que tu pago. Se descuenta de tu próximo pago.",
    owedNote: "Debías {amount} de la semana del {date}. Se descuenta esta semana.",
    frozen: "Esta semana está pagada. El trabajo después va en la semana del {date}.",
    lateRow: "De la semana del {date}, hecho después de pagarla",
    changeRow: "Cambio a un trabajo después de pagar la semana del {date}",
    hoursRow: "Cambio a las horas de la semana del {date}",
    noLines: "No hay trabajos en esta semana.",
    back: "Todas las semanas",
    clockIn: "Marcar entrada",
    clockOut: "Marcar salida",
    onClock: "Trabajando desde las {time}",
    offClock: "Sin marcar",
    today: "Hoy {hours}",
    clockedIn: "Entrada marcada",
    clockedOut: "Salida marcada",
  },
} as const;
export type PayWord = keyof (typeof PAY_WORDS)["en"];

/** The words for a person's language (Spanish for "es", English otherwise). */
export function payWords(locale: string | null | undefined): Record<PayWord, string> {
  return PAY_WORDS[locale === "es" ? "es" : "en"];
}

/** Fills {name} marks in a phrase. */
export function fillWords(phrase: string, values: Record<string, string>): string {
  return phrase.replace(/\{(\w+)\}/g, (m, k: string) => values[k] ?? m);
}
